import { render, staticRenderFns } from "./AccommodationDeleteModal.vue?vue&type=template&id=6fe2ce97&"
import script from "./AccommodationDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AccommodationDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports